import CloseModalIcon from "../../shared-components/icons/CloseModalIcon";
import { useSubscriptionContext } from "./subscriptionContext";
import dayjs from "dayjs";

const removeRenewParam = () => {
  const url = new URL(window.location.href);
  if (url.searchParams.has("renew")) {
    url.searchParams.delete("renew");
    window.history.replaceState({}, "", url.pathname + url.search);
  }
};

const RenewSubscriptionModal = () => {
  const { setIsRenewSubscriptionModalOpen, subscription, activePricePlan, onRenewSubscription, isRenewButtonDisabled } =
    useSubscriptionContext();

  const handleDismiss = () => {
    removeRenewParam();
    setIsRenewSubscriptionModalOpen(false);
  };

  return (
    <div>
      <div data-name="Overlay" className="fixed inset-0 z-[9999] bg-black/80" />
      <div
        data-name="PopupContainer"
        className={"fixed inset-0 z-[99999] w-full min-h-full overflow-x-hidden overflow-y-auto"}>
        <div className={"w-full min-h-full flex-center flex-col m-auto"}>
          <div
            className={
              "bg-white relative w-full lg:max-w-[1000px] lg:min-h-[614px] px-4 pt-10 pb-3 lg:px-14 lg:pb-6 flex flex-col max-lg:grow lg:rounded-2xl"
            }>
            <button
              onClick={handleDismiss}
              className={"absolute flex items-center justify-center right-3 top-3 lg:right-4 lg:top-4 lg:size-10"}>
              <CloseModalIcon className={"size-6 text-gray-5"} />
            </button>
            <div data-name={"modal-step-4"} className={"h-full grow flex flex-col"}>
              <div className={"scroll-wrapper grow"}>
                <div className={"mb-6 lg:mb-10"}>
                  <div
                    className={
                      "text-dark-1 text-center font-jost text-xl font-semibold leading-6.5 mb-1.5 lg:text-[28px] lg:leading-8"
                    }>
                    {"Renew your subscription"}
                  </div>
                </div>

                <div className={"w-full lg:max-w-[480px] lg:mx-auto"}>
                  <div className="py-4 lg:py-4 px-4 lg:px-6 rounded-lg bg-gray-4">
                    <div className={" text-gray-1 uppercase text-xs font-normal leading-4 lg:text-sm lg:leading-5"}>
                      Current subscription
                    </div>
                    <hr className="my-3" />
                    <div className="min-h-28 flex flex-col lg:flex-row gap-4">
                      <div className={""}>
                        <h3 className="text-gray-1 text-left text-base font-semibold leading-5.5 !mb-0 lg:text-lg lg:leading-6 uppercase">
                          {subscription.name}
                        </h3>
                        <div className="flex items-center mt-1">
                          <span className="text-dark-1 font-jost font-bold text-[28px] leading-8 lg:text-[32px] lg:leading-10">
                            £{activePricePlan.unit_amount / 100}
                            <span className={"text-gray-1 font-jost text-base font-medium leading-5.5"}>
                              /{subscription.interval}
                            </span>
                          </span>
                        </div>
                        <div className="text-secondary font-jost mt-4 text-sm font-normal leading-5">
                          This subscription will no longer be cancelled. It will renew on{" "}
                          <span className={"text-dark-1 font-medium"}>
                            {dayjs(subscription.current_period_end * 1000).format("DD MMMM YYYY")}
                          </span>
                          .
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mt-4 text-gray-5 font-jost text-[11px] font-normal leading-3.5 lg:text-xs lg:leading-4.5">
                    By renewing your subscription, you maintain your consent for recurring billing and for subscription
                    conditions, in accordance with BOTB{" "}
                    <a
                      href="https://www.botb.com/terms"
                      title={"Terms of Service"}
                      className={"!underline text-primary"}>
                      Terms and Conditions
                    </a>{" "}
                    and{" "}
                    <a
                      href="https://www.botb.com/privacy"
                      title={"Privacy Policy"}
                      className={"!underline text-primary"}>
                      Privacy Policy
                    </a>
                  </div>
                </div>
              </div>

              <div className={"flex max-lg:flex-col gap-2 lg:justify-end mt-6 lg:mt-8"}>
                <button
                  disabled={isRenewButtonDisabled}
                  onClick={onRenewSubscription}
                  className={
                    "theme-btn theme-btn-primary theme-btn-md uppercase max-lg:w-full lg:order-2 lg:min-w-[220px]"
                  }>
                  Renew subscription
                </button>
                <button
                  onClick={handleDismiss}
                  className={"theme-btn theme-btn-md uppercase max-lg:w-full text-primary lg:order-1"}>
                  Go back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RenewSubscriptionModal;
